import {Injectable} from '@angular/core';
import {ApiService} from '../api/api.service';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TranslationsService {
  private translations                 = {};
  private translationsFetched: boolean = false;
  public newTranslationsNotifier       = new Subject<any>();

  constructor(private api: ApiService) {
  }

  public get(translation) {
    if (this.translations.hasOwnProperty(translation)) {
      return this.translations[translation];
    }
    return translation;
  }

  public fetchTranslations() {
    const vm = this;
    this.api.get('v1/translations/all').then((data) => {
      this.translations = data;
      this.newTranslationsNotifier.next(data);
    });
  }
}
